import React, { useEffect, useRef } from 'react';
import { Box, Button, Typography } from '@mui/material';
import MyStudySidekick from './MyStudySidekick';
import PageLoader from './PageLoader';

function AIResponseLoader({
  poll,
  isComplete,
  isErrored = () => false,
  onComplete,
  interval = 10 * 1000,
  message = 'The requested resource is being generated. This may take a few minutes.\nGeneration will continue upon navigating away from this screen.',
  resource = 'Resource',
  onGenerateNew,
  onGoToDashboard,
}) {
  const pollRef = useRef(poll);
  const isCompleteRef = useRef(isComplete);
  const isErroredRef = useRef(isErrored);
  const onCompleteRef = useRef(onComplete);
  pollRef.current = poll;
  isCompleteRef.current = isComplete;
  isErroredRef.current = isErrored;
  onCompleteRef.current = onComplete;

  useEffect(() => {
    let cancelled = false;
    let timeoutId;

    const checkStatus = async () => {
      try {
        const data = await pollRef.current();
        // Ignore a response that resolves after cleanup already ran (unmount, or interval changed).
        if (cancelled) return;
        // Stop polling once the resource reaches either of the terminal state: completed or errored.
        if (isCompleteRef.current(data) || isErroredRef.current(data)) {
          onCompleteRef.current(data);
        } else {
          // Recursive setTimeout, not setInterval — waits for this poll to resolve
          // before scheduling the next one, so requests can't overlap.
          timeoutId = setTimeout(checkStatus, interval);
        }
      } catch (err) {
        console.log(err);
      }
    };

    checkStatus();

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [interval]);

  return (
    <Box className="mss__box mss__aiResponseLoader">
      <PageLoader className="loaderIcon" />

      <MyStudySidekick id="aiResponseLoader__title" className="loaderTitle" />

      <Typography className="loaderMessage">{message}</Typography>

      <Box className="loaderActions">
        {onGoToDashboard && (
          <Button variant="contained" className="mss__button" onClick={onGoToDashboard}>
            Go to Dashboard
          </Button>
        )}
        {onGenerateNew && (
          <Button variant="contained" className="mss__button primary" onClick={onGenerateNew}>
            Generate New {resource}
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default AIResponseLoader;
